import { render, staticRenderFns } from "./MainPicUpload.vue?vue&type=template&id=0d6a4216&scoped=true&"
import script from "./MainPicUpload.vue?vue&type=script&lang=js&"
export * from "./MainPicUpload.vue?vue&type=script&lang=js&"
import style0 from "./MainPicUpload.vue?vue&type=style&index=0&id=0d6a4216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a4216",
  null
  
)

export default component.exports